import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Pause, Play } from 'lucide-react';
export const SlideShowSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const slides = [{
    id: 1,
    title: 'Del campo a tu plato',
    subtitle: 'La historia del Angus Beef',
    description: 'Criados en los mejores pastos, seleccionados con los más altos estándares de calidad.',
    image: 'https://images.unsplash.com/photo-1516822669470-7f8c2b9b0cb9?q=80&w=2940&auto=format&fit=crop'
  }, {
    id: 2,
    title: 'Un linaje de sabor',
    subtitle: 'La raza Angus',
    description: 'Reconocida mundialmente por su marmoleo excepcional y sabor inigualable.',
    image: 'https://images.unsplash.com/photo-1588168333986-5078d3ae3976?q=80&w=2940&auto=format&fit=crop'
  }, {
    id: 3,
    title: 'Certificación mundial',
    subtitle: 'Garantía de excelencia',
    description: 'Solo el 3% de la carne de res cumple con los estándares para ser Certified Angus Beef.',
    image: 'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?q=80&w=2940&auto=format&fit=crop'
  }, {
    id: 4,
    title: 'Maestría en la parrilla',
    subtitle: 'El arte del fuego',
    description: 'Cada corte es sellado a la perfección, preservando sus jugos naturales y sabor intenso.',
    image: 'https://images.unsplash.com/photo-1558030006-450675393462?q=80&w=2831&auto=format&fit=crop'
  }, {
    id: 5,
    title: 'Perla Negra',
    subtitle: 'La Powerhouse del Angus Beef',
    description: 'El destino obligado para los amantes de la buena carne en el oriente de Guatemala.',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=2940&auto=format&fit=crop'
  }, {
    id: 6,
    title: 'Experiencia pirata premium',
    subtitle: 'Donde la aventura encuentra el lujo',
    description: 'Un ambiente único que combina la mística pirata con la elegancia de un steakhouse de clase mundial.',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=2874&auto=format&fit=crop'
  }, {
    id: 7,
    title: 'Cortes premium',
    subtitle: 'Selección exclusiva',
    description: 'Ribeye, New York Strip, Filet Mignon y más. Cada corte elegido por nuestros expertos.',
    image: 'https://images.unsplash.com/photo-1603360946369-dc9bb6258143?q=80&w=2940&auto=format&fit=crop'
  }, {
    id: 8,
    title: 'Cocción perfecta',
    subtitle: 'Temperatura precisa',
    description: 'Nuestros chefs dominan el arte de la cocción, desde rare hasta well-done, según tu preferencia.',
    image: 'https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=2938&auto=format&fit=crop'
  }, {
    id: 9,
    title: 'En el corazón de Zacapa',
    subtitle: 'Un tesoro del oriente',
    description: 'Ubicados estratégicamente para servir a toda la región con la mejor carne Angus de Guatemala.',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=2940&auto=format&fit=crop'
  }, {
    id: 10,
    title: 'Tradición y calidad',
    subtitle: 'Nuestro compromiso',
    description: 'Cada plato es una promesa cumplida: calidad superior, sabor excepcional, experiencia inolvidable.',
    image: 'https://images.unsplash.com/photo-1615937657715-bc7b4b7962c1?q=80&w=2940&auto=format&fit=crop'
  }, {
    id: 11,
    title: 'Navega con nosotros',
    subtitle: 'La aventura del sabor',
    description: '¡Bienvenido a bordo del Perla Negra, donde cada comida es una travesía épica!',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=2940&auto=format&fit=crop'
  }];
  useEffect(() => {
    if (!isPlaying) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides.length, isPlaying]);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };
  return <section id="historia" className="py-20 px-4 bg-pirate-black relative" data-id="element-137">
      <div className="container mx-auto" data-id="element-138">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-pirata text-4xl md:text-5xl text-center mb-16" data-id="element-139">
          Historia del Angus Beef
        </motion.h2>
        <div className="relative max-w-6xl mx-auto rounded-2xl overflow-hidden shadow-2xl h-[500px] md:h-[600px]" data-id="element-140">
          <AnimatePresence mode="wait" data-id="element-141">
            <motion.div key={currentSlide} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 1
          }} className="absolute inset-0" data-id="element-142">
              <motion.div initial={{
              scale: 1.1
            }} animate={{
              scale: 1
            }} exit={{
              scale: 1.1
            }} transition={{
              duration: 7,
              ease: 'easeOut'
            }} className="absolute inset-0 bg-cover bg-center" style={{
              backgroundImage: `url(${slides[currentSlide].image})`
            }} data-id="element-143"></motion.div>
              <div className="absolute inset-0 bg-gradient-to-t from-pirate-black via-pirate-black/60 to-transparent" data-id="element-144"></div>
              <div className="absolute inset-0 bg-gradient-to-r from-pirate-black/80 via-transparent to-pirate-black/40" data-id="element-145"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-16" data-id="element-146">
                <motion.div initial={{
                opacity: 0,
                x: -50
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: 0.3,
                duration: 0.8
              }} className="max-w-3xl" data-id="element-147">
                  <motion.p initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 0.5,
                  duration: 0.6
                }} className="text-pirate-red font-pirata text-xl md:text-2xl mb-2" data-id="element-148">
                    {slides[currentSlide].subtitle}
                  </motion.p>
                  <motion.h3 initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 0.7,
                  duration: 0.6
                }} className="font-pirata text-4xl md:text-6xl mb-4 text-white" data-id="element-149">
                    {slides[currentSlide].title}
                  </motion.h3>
                  <motion.p initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 0.9,
                  duration: 0.6
                }} className="text-lg md:text-2xl text-gray-200 leading-relaxed" data-id="element-150">
                    {slides[currentSlide].description}
                  </motion.p>
                  <motion.div initial={{
                  opacity: 0
                }} animate={{
                  opacity: 1
                }} transition={{
                  delay: 1.1,
                  duration: 0.6
                }} className="mt-6 flex items-center space-x-2" data-id="element-151">
                    <div className="h-1 bg-pirate-red w-12" data-id="element-152"></div>
                    <span className="text-sm text-gray-400" data-id="element-153">
                      {String(currentSlide + 1).padStart(2, '0')} /{' '}
                      {String(slides.length).padStart(2, '0')}
                    </span>
                  </motion.div>
                </motion.div>
              </div>
            </motion.div>
          </AnimatePresence>
          <div className="absolute top-1/2 left-0 right-0 -translate-y-1/2 flex justify-between px-4 md:px-8 z-10" data-id="element-154">
            <motion.button whileHover={{
            scale: 1.1,
            x: -5
          }} whileTap={{
            scale: 0.9
          }} onClick={prevSlide} className="bg-pirate-black/70 backdrop-blur-sm p-3 md:p-4 rounded-full hover:bg-pirate-red/80 transition-all focus:outline-none focus:ring-2 focus:ring-white" aria-label="Previous slide" data-id="element-155">
              <ChevronLeft className="text-white" size={28} data-id="element-156" />
            </motion.button>
            <motion.button whileHover={{
            scale: 1.1,
            x: 5
          }} whileTap={{
            scale: 0.9
          }} onClick={nextSlide} className="bg-pirate-black/70 backdrop-blur-sm p-3 md:p-4 rounded-full hover:bg-pirate-red/80 transition-all focus:outline-none focus:ring-2 focus:ring-white" aria-label="Next slide" data-id="element-157">
              <ChevronRight className="text-white" size={28} data-id="element-158" />
            </motion.button>
          </div>
          <motion.button whileHover={{
          scale: 1.1
        }} whileTap={{
          scale: 0.9
        }} onClick={togglePlayPause} className="absolute top-6 right-6 bg-pirate-black/70 backdrop-blur-sm p-3 rounded-full hover:bg-pirate-red/80 transition-all focus:outline-none focus:ring-2 focus:ring-white z-10" aria-label={isPlaying ? 'Pause slideshow' : 'Play slideshow'} data-id="element-159">
            {isPlaying ? <Pause className="text-white" size={20} data-id="element-160" /> : <Play className="text-white" size={20} data-id="element-161" />}
          </motion.button>
          <div className="absolute bottom-6 left-0 right-0 flex justify-center space-x-2 z-10" data-id="element-162">
            {slides.map((_, index) => <motion.button key={index} onClick={() => setCurrentSlide(index)} whileHover={{
            scale: 1.2
          }} className={`h-2 rounded-full transition-all focus:outline-none ${currentSlide === index ? 'bg-pirate-red w-8' : 'bg-white/40 w-2 hover:bg-white/60'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-163">
                {currentSlide === index && <motion.div layoutId="activeSlide" className="h-full bg-pirate-red rounded-full" initial={false} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-164" />}
              </motion.button>)}
          </div>
        </div>
      </div>
    </section>;
};